import React from 'react'

import {
  List,
  Datagrid,
  ChipField,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  EditButton,
  ShowButton,
  Edit,
  SimpleForm,
  DisabledInput,
  TextInput,
  Create,
  DateInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  LongTextInput,
} from 'admin-on-rest'

import {
  referenceKeyParser,
  referenceKeyFormatter,
  dateFormatter,
  dateParser,
} from '../helpers'

import DateTimeInput from '../components/DateTimeInput'

const CourseTitle = ({ record }) => {
  return <span>{record ? `"${record.name}"` : ''}</span>
}

export const AdminCourseEdit = props => (
  <Edit title={<CourseTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput source="name" />
      <LongTextInput source="description" />
      <DateTimeInput
        label="Data curs"
        source="date"
        showTime
        options={{
          mode: 'landscape',
          hintText: 'Alegeti o data',
          okLabel: 'OK',
          cancelLabel: 'Anulare',
          locale: 'ro',
        }}
        format={dateFormatter}
        parse={dateParser}
      />
      <TextInput label="Locatie" source="location" />
      <NumberInput label="Credite" source="credits" step="1" />
      <NumberInput label="Cost in RON" source="cost" step="10" />
      <NumberInput
        label="Locuri disponibile"
        source="availableSpots"
        step="5"
      />
      <ReferenceInput
        label="Lector"
        source="instructors"
        reference="instructors"
        allowEmpty
        parse={referenceKeyParser}
        format={referenceKeyFormatter}
      >
        <SelectInput optionText="displayName" />
      </ReferenceInput>
      {/* <NumberInput source="attendees.min" step="1" />
      <NumberInput source="attendees.max" step="1" /> */}
    </SimpleForm>
  </Edit>
)



// WEBPACK FOOTER //
// ./src/admin/AdminCourseEdit.js